import * as ng from 'angular';
import { Ngenter } from './ngenter.directive';

export const NgenterModule: string =
    ng.module('ngenter', [
    ])
        .directive('ngenter', Ngenter)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/ngenter/ngenter.module.ts